export const MY_PROFILE = 'MY_PROFILE';
export const MY_PROFILE_SUCCESS = 'MY_PROFILE_SUCCESS';
export const MY_PROFILE_ERROR = 'MY_PROFILE_ERROR';

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';
